import React, { Component } from 'react';
import { Table, ButtonToolbar, Button, Modal } from 'react-bootstrap';

import { DataIdentifierOptionsFormatHelper } from '../helpers/DataIdentifierOptionsFormatHelper';

export class TextOptionsPickerModal extends Component {
    render() {
        const { show, options } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>OPÇÕES PARA CONTEÚDO DO TEXTO</Modal.Header>
                <Modal.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Opção</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map((option, idx) =>
                                    <tr className="selectable" key={`data-${idx}`}>
                                        <td onClick={() => this.props.onSelect(DataIdentifierOptionsFormatHelper.getOptionValue(option))}>
                                            {DataIdentifierOptionsFormatHelper.getOptionText(option)}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <ButtonToolbar>
                        <Button onClick={this.props.onHide}>CANCELAR</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
